import { UseFormRegisterReturn } from "react-hook-form";

interface LoginInputProps {
  label: string;
  type: string;
  placeholder: string;
  registration: UseFormRegisterReturn;
  error?: string;
}

const LoginInput = ({
  label,
  type,
  placeholder,
  registration,
  error,
}: LoginInputProps) => (
  <div>
    <label className="mb-2 block text-sm font-semibold text-white">
      {label}
    </label>
    <input
      type={type}
      {...registration}
      className={`focus:ring-brand-primary focus:border-brand-primary w-full rounded-lg border bg-white/95 px-4 py-3 text-base transition duration-200 focus:outline-none focus:ring-2 ${
        error ? "border-red-500" : "border-neutral-300"
      }`}
      placeholder={placeholder}
    />
    {error && <p className="mt-1 text-sm text-red-300">{error}</p>}
  </div>
);

export default LoginInput;
